export default __webpack_public_path__ + "static/media/FIL.8d05cdba.svg";